import { render, staticRenderFns } from "./sensitiveWord-topbar.vue?vue&type=template&id=95ad6d20&scoped=true"
import script from "./sensitiveWord-topbar.vue?vue&type=script&lang=js"
export * from "./sensitiveWord-topbar.vue?vue&type=script&lang=js"
import style0 from "./sensitiveWord-topbar.vue?vue&type=style&index=0&id=95ad6d20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95ad6d20",
  null
  
)

export default component.exports